import { render, staticRenderFns } from "./SaveButton.vue?vue&type=template&id=79b458ae&scoped=true"
import script from "./SaveButton.vue?vue&type=script&lang=js"
export * from "./SaveButton.vue?vue&type=script&lang=js"
import style0 from "./SaveButton.vue?vue&type=style&index=0&id=79b458ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "79b458ae",
  null
  
)

export default component.exports